import { createContext } from 'react';

export interface AlbumConfig {
  albumId: number;
  isOffsite?: boolean;
  isOwnerOrAdmin: boolean;
  hashedPass: string;
  navIsHidden: boolean;
}

const AlbumConfigContext = createContext<AlbumConfig>({
  albumId: 0,
  isOwnerOrAdmin: false,
  hashedPass: '',
  navIsHidden: false,
});

export default AlbumConfigContext;
